import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames, { Value as ClassValue } from "classnames";
import React, { CSSProperties, useState } from "react";

export function CollapsibleSection(props: {
  title: React.ReactNode;
  children?: React.ReactNode;
  isDisabled?: boolean;
  theme?: {
    containerStyle?: React.CSSProperties;
    header?: {
      className?: ClassValue;
      style?: CSSProperties;
    };
  };
}) {
  const isDisabled = props.isDisabled === true;
  const [isExpanded, setExpanded] = useState(false);
  return (
    <div
      className="card"
      style={{
        marginTop: "1em",
        marginBottom: "1em",
        opacity: isDisabled ? "50%" : undefined,
        ...props?.theme?.containerStyle,
      }}
    >
      <header
        className={classNames("card-header", props?.theme?.header?.className)}
        onClick={() => (isDisabled ? null : setExpanded(prev => !prev))}
        style={props?.theme?.header?.style}
      >
        <span className="card-header-title">{props.title}</span>
        <span className="card-header-icon">
          <span className="icon">
            <FontAwesomeIcon
              icon={isExpanded ? faChevronUp : faChevronDown}
              aria-hidden="true"
            />
          </span>
        </span>
      </header>
      <div
        id="collapsible-card"
        className={classNames("is-collapsible is-active", {
          "is-hidden": !isExpanded,
        })}
        style={{ overflowY: "visible" }}
      >
        <div className="card-content">{props.children}</div>
      </div>
    </div>
  );
}
